import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

const FIELD_BOX =
  "mt-2 rounded-xl bg-bone border-sage focus-visible:ring-terracotta focus-visible:ring-1 focus-visible:border-[#D47A6A] text-ink placeholder:text-ink-muted/70";

const LABEL = "text-[0.68rem] tracking-[0.22em] uppercase font-semibold text-terracotta";

function Field({ id, label, value, onChange, textarea = false, testId, placeholder }) {
  return (
    <div>
      <Label htmlFor={id} className={LABEL}>
        {label}
      </Label>
      {textarea ? (
        <Textarea
          id={id}
          data-testid={testId}
          value={value ?? ""}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder || "Not provided"}
          rows={3}
          className={`${FIELD_BOX} min-h-[96px] resize-y`}
        />
      ) : (
        <Input
          id={id}
          data-testid={testId}
          value={value ?? ""}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder || "Not provided"}
          className={`${FIELD_BOX} h-11`}
        />
      )}
    </div>
  );
}

export default function BugPreviewForm({ bug, onChange }) {
  const set = (key) => (val) => onChange({ ...bug, [key]: val });

  return (
    <div className="grid sm:grid-cols-2 gap-5" data-testid="bug-preview-form">
      <div className="sm:col-span-2">
        <Field
          id="title"
          label="Title"
          value={bug.title}
          onChange={set("title")}
          testId="bug-field-title"
          placeholder="Short, meaningful title"
        />
      </div>

      <Field
        id="restaurant_id"
        label="Restaurant Id"
        value={bug.restaurant_id}
        onChange={set("restaurant_id")}
        testId="bug-field-restaurant-id"
      />
      <Field
        id="restaurant_name"
        label="Restaurant name"
        value={bug.restaurant_name}
        onChange={set("restaurant_name")}
        testId="bug-field-restaurant-name"
      />

      <div className="sm:col-span-2">
        <Field
          id="what_trying_to_do"
          label="What I was trying to do"
          value={bug.what_trying_to_do}
          onChange={set("what_trying_to_do")}
          textarea
          testId="bug-field-what-trying"
        />
      </div>
      <div className="sm:col-span-2">
        <Field
          id="what_happened"
          label="What happened"
          value={bug.what_happened}
          onChange={set("what_happened")}
          textarea
          testId="bug-field-what-happened"
        />
      </div>
      <div className="sm:col-span-2">
        <Field
          id="what_should_have_happened"
          label="What should have happened"
          value={bug.what_should_have_happened}
          onChange={set("what_should_have_happened")}
          textarea
          testId="bug-field-what-should"
        />
      </div>

      <Field
        id="when_did_this_happen"
        label="When did this happen"
        value={bug.when_did_this_happen}
        onChange={set("when_did_this_happen")}
        testId="bug-field-when"
      />
      <Field
        id="attachment"
        label="Attachment: Screenshot / Video (if any)"
        value={bug.attachment}
        onChange={set("attachment")}
        testId="bug-field-attachment"
      />
    </div>
  );
}
